import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StringUtils, ObjectUtils, sortAscend, newUuid } from '@ark-libs/ngx-utils';

import { CoreConfig } from '../config/core-config';
import { CoreConfigService } from '../config/core-config.service';
import { Principal } from '../auth/principal.service';

export class AbstractDataService<T> {
    private DATA_UUID = "__cached_data_uuid";
    private NODE_UUID = "__cached_node_uuid";

    private cachedDatas: { url: string, params?: { [key: string]: any }, promise?: Promise<T>, data?: T, dataUuid?: string, }[] = [];
    private cachedLists: { [dataUuid: string]: T[] } = {};

    private _injector: Injector
    private _http: HttpClient;
    private _principal: Principal;
    private _accountId;
    private _configService: CoreConfigService;
    ignoreHttpError: boolean = true;

    constructor(injector: Injector) {
        this._injector = injector;
        this._configService = injector.get(CoreConfigService);
        this._principal = injector.get(Principal);
        this._principal.authenticationStateChange.subscribe(account => {
            this.clearCache();
        });
    }

    private clearCache() {
        // console.log("clearCache()");
        this.cachedDatas = [];
        this.cachedLists = {};
    }
    private treeToList(treeNode: T): T[] {
        if (treeNode == null) return [];
        treeNode[this.NODE_UUID] = newUuid();
        const list = [];
        list.push(treeNode);

        let children = this.getChildren(treeNode);
        if (children && children.length > 0) {
            children.sort((a, b) => this.sort(a, b)).forEach(child => {
                this.treeToList(child).forEach(listItem => {
                    if (!list.some(present => this.getKey(present) == this.getKey(listItem))) list.push(listItem);
                });
            });
        }
        return list;
    }
    private filterMatch(cachedParams: {}, requestParams: {}): boolean {
        return ObjectUtils.isEquals(cachedParams, requestParams);
        // return Object.keys(cachedParams).every(key=>cachedParams[key] == requestParams[key])?
        //        Object.keys(requestParams).every(key=>cachedParams[key] == requestParams[key]):false;
    }
    private tohttpRequestParams(params: { [key: string]: any }): { [key: string]: string|string[] } {
        const result = {};
        let v;
        Object.keys(params).forEach(key => {
            v = params[key];
            if (v) {
                if (typeof v === 'string') { }
                else if (typeof v === 'number') v = v.toString();
                else if (Array.isArray(v)){
                    for(let i = 0; i < v.length; i ++) v[i] = v[i]==null?"":v[i].toString();
                }else v = encodeURI(JSON.stringify(v));
                result[key] = v;
            }
        });
        //result["timestamp"] = (new Date()).valueOf().toString();//用于避免浏览器缓存
        return result;
    }
    public get apiUrls() {
        return this._configService.apiUrls;
    }
    public get config(): CoreConfig {
        return this._configService;
    }
    
    // protected getConfiguredApiUrl(key: string): string{
    //     return this._configService.getApiUrl(key);
    // }
    /**
     * 获取键值，默认首选id为键值，其次使用name
     */
    protected getKey(item: T): string {
        return item['id'] ? item['id'] : item['name'];
    }
    protected sort(a: T, b: T): number {
        if (a['seq'] || b['seq']) return sortAscend(a['seq'], b['seq']);
        return sortAscend(a['index'], b['index']);
    }
    protected getChildren(item): T[] {
        if (item && item.children && Array.isArray(item.children)) return item.children;
        if (item && item.items && Array.isArray(item.items)) return item.items;
        return null;
    }
    protected getPlainList(data: T) {
        if (!data) return [];

        const uuid = data[this.DATA_UUID];
        if (uuid) {
            let list = this.cachedLists[uuid];
            if (list == null) {
                list = this.treeToList(data);
                this.cachedLists[uuid] = list;
            }
            return list;
        } else {
            return [];
        }
    }
    protected httpGet(url: string, requestParams?: { [key: string]: any }): Promise<any> {
        if (!requestParams) requestParams = {};
        let cachedDataItem = this.cachedDatas.filter(item => {
            return StringUtils.isEqualIgnoreCase(item.url, url) ?
                this.filterMatch(item.params, requestParams) : false;
        }).pop();
        if (cachedDataItem == null) {
            cachedDataItem = { url: url, params: requestParams };
            this.cachedDatas.push(cachedDataItem);
        }
        if (cachedDataItem.data) return Promise.resolve(ObjectUtils.cloneObject(cachedDataItem.data, true));
        if (cachedDataItem.promise) return cachedDataItem.promise;

        if (this._http == null) this._http = this._injector.get(HttpClient);
        const promise = this._http.get<T>(url, { params: this.tohttpRequestParams(requestParams) }).toPromise().then(data => {
            cachedDataItem.promise = null;
            if (data == null) return null;

            const uuid = newUuid();
            data[this.DATA_UUID] = uuid;
            cachedDataItem.dataUuid = uuid;
            cachedDataItem.data = data;

            // console.log(`UaaResourceService.getWholeAppTree('${name}','${types}') --> load data --> OK`);
            return ObjectUtils.cloneObject(data, true);
        }).catch(error => {
            // console.error(`AbstractDataService.httpGet() error --> ${error.message}\n`, error);
            cachedDataItem.promise = null;
            return this.ignoreHttpError ? null : Promise.reject(error);
        });
        cachedDataItem.promise = promise;
        return promise;
    }
    protected buildSimpleStatement(statement: string | string[], op?: string): any {
        if (Array.isArray(statement)) {
            return { op: op ? op : "AND", simpleStatements: statement };
        } else {
            return { simpleStatement: statement };
        }
    }
}
